import React from "react";
import Slider from "react-slick";
const defaultImage = require('../../media/sancoIcon_trans.png');

export class SpeciesScoresVertTv extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      boatScores: [],
      logs: this.props.logs,
      classLogs: [],
      boatClass: this.props.boatClass,
      speciesId: this.props.speciesId,
      speciesName: this.props.speciesName,
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, speciesId: newProps.speciesId, speciesName: newProps.speciesName, boatClass: newProps.boatClass});
    this.classFilter();
  }
    
  classFilter() {
      var logs = this.state.logs;
      var classLogs = [];
      if(!this.state.boatClass) {
          return;
      }
      logs.forEach((boat) => {
          if(boat.boatClass === this.state.boatClass) {
              classLogs.push({
                  boatCaughtFish: boat.boatCaughtFish,
                  boatClass: boat.boatClass,
                  boatId: boat.boatId,
                  boatName: boat.boatName,
                  boatThm: boat.boatThm,
                  lastFishTime: boat.lastFishTime
              })
          }
      })
    this.getSpeciesPoints(this.state.speciesId, classLogs)
  }

  getSpeciesPoints(speciesId, classLogs) {
    var boatTotals = [];
    var logs = classLogs;
    logs.forEach((boatLog) => {
      var totalPoints = 0;
      var speciesCount = 0;
      boatLog.boatCaughtFish.forEach((log) => {
        if(speciesId === log.speciesId && log.lbs > 0) {
          totalPoints = totalPoints + parseFloat(log.lbs);
        }
        if(speciesId === log.speciesId) {
          speciesCount++
        }
      });
      var points = parseFloat(totalPoints.toFixed(2));
      if(points > 0){
        var d = new Date(boatLog.lastFishTime);
        boatTotals.push({
          id: boatLog.boatId,
          boatName: boatLog.boatName,
          boatThm: boatLog.boatThm,
          total: points,
          lastFishTime: boatLog.lastFishTime,
          lastTime: parseInt(Math.round(d.getTime() / 1000))
        })
      }
    })
    this.scoreSortFilter(boatTotals);
  }

  scoreSortFilter(boatTotals) {
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    if(boatTotals && boatTotals.length >= 1) {
      boatTotals.sortOn("total", "lastTime");
      boatTotals.reverse();
    }
  
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    if(boatTotals && boatTotals.length >= 1) {
      var boatScoresArray = boatTotals.filter(filterByTotal);
      var rank = 1;
      var bScores = [];
      boatScoresArray.forEach((boat) => {
        bScores.push({
          rank: rank++,
          boat: boat
        })
      })
      this.setState({
        boatScores: bScores,
      })
    }else {
      return
    }
  }
  
  render() {
    
    const settings = {
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
    };
    return (
        <div className="speciesScores-boxTvPT">
          { this.state.boatScores ? <Slider {...settings}>
          { this.state.boatScores.map(boat => (
            <div id='rank-box' className="boatBox" style={{width: '90%', margin: 10, padding: 5}} key={boat.boat.id}>
              {boat.boat.boatThm ? 
                <div id='boat-total' 
                  style={{
                    position: 'relative',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '50% 50%',
                    borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
                    borderSize: 4,
                    borderStyle: 'solid',
                    width: '100%', 
                    height: boat.rank === 1 ? 180 : 155, 
                    backgroundImage: 'url(' + boat.boat.boatThm + ')'
                  }}>
                    <div id='boat-rank' style={{height: 25, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 18, backgroundColor: '#ccc', color: '#191970', overflow: 'hidden', textOverflow:'clip'}}>
                      <center>{boat.boat.boatName} </center>
                    </div>
                    <div id='rank'
                      style={{
                        backgroundColor: 'white',
                        width: 40,
                        height: 40,
                        borderRadius: 20,
                        float: 'left',
                        marginTop: -25,
                        marginRight: 5,
                        fontWeight: 'bold', 
                        fontSize: 22,
                        opacity: .7,
                      }}> 
                     <center style={{lineHeight: 1.8}}> # {boat.rank}</center>
                    </div>
                    <div id='boat-total' style={{height: 25, width: '60%', float: 'right', fontWeight: 'bold', fontSize: 18, backgroundColor: '#fff', color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute', bottom: 0, right: 0, opacity: .6}}>
                      <center>Pts: {boat.boat.total}</center>
                    </div>
                  </div> :
                <div id='boat-total' 
                  style={{
                    position: 'relative',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#ccc',
                    backgroundPosition: '50% 50%',
                    borderColor: boat.rank === 1 ? '#DAA520' : '#ccc', 
                    borderSize: 4,
                    borderStyle: 'solid',
                    width: '100%', 
                    height: boat.rank === 1 ? 180 : 155, 
                    backgroundImage: 'url(' + defaultImage + ')'
                  }}>
                    <div id='boat-rank' style={{height: 25, width: '100%', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', fontSize: 18, backgroundColor: '#ccc', color: '#191970', overflow: 'hidden', textOverflow:'clip'}}>
                      <center>{boat.boat.boatName} </center>
                    </div>
                    <div id='rank'
                      style={{
                        backgroundColor: 'white',
                        width: 40,
                        height: 40,
                        borderRadius: 20,
                        float: 'left',
                        marginTop: -25,
                        marginRight: 5,
                        fontWeight: 'bold', 
                        fontSize: 22,
                        opacity: .7,
                      }}> 
                     <center style={{lineHeight: 1.8}}> # {boat.rank}</center>
                    </div>
                    <div id='boat-total' style={{height: 25, width: '60%', float: 'right', fontWeight: 'bold', fontSize: 18, backgroundColor: '#fff', color: '#191970', borderColor: '#ddd', borderWidth: 1, borderStyle: 'solid',position: 'absolute', bottom: 0, right: 0, opacity: .6}}>
                      <center>Pts: {boat.boat.total}</center>
                    </div>
                  </div>
                }
            </div>
          ))}
        </Slider> : <div style={{color: '#fff', fontSize: 24}}>No fish logged yet.</div> 
        }
        <div className="division_title_tv">{ this.state.boatClass } { this.state.speciesName } Division</div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CompsTv/SpeciesScoresVertTv.js